import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ReleaseNotesApiService } from '../http/release-notes-api.service';
import { ReleaseNote } from 'src/app/shared/models/release-note';
import { SaveResponse } from '../../models/save-response';

@Injectable({
    providedIn: 'root'
})
export class ReleaseNotesService {
    constructor(private releaseNotesApiService: ReleaseNotesApiService) {}
    private cachedReleaseNotes: ReleaseNote[] | null;

    getReleaseNotes(): Observable<ReleaseNote[]> {
        if (this.cachedReleaseNotes) {
            return of(this.cachedReleaseNotes);
        }
        return this.releaseNotesApiService.getReleaseNotes().pipe(
            tap(response => {
                this.cachedReleaseNotes = response;
            }),
            catchError(async (errorResponse: HttpErrorResponse) => {
                this.clearCache();
                throw errorResponse;
            })
        );
    }

    deleteReleaseNote(releaseNoteId: number): Observable<void> {
        return this.releaseNotesApiService.deleteReleaseNote(releaseNoteId).pipe(
            tap(() => {
                this.clearCache();
            }),
            catchError(async (errorResponse: HttpErrorResponse) => {
                throw errorResponse;
            })
        );
    }

    getReleaseNote(releaseNoteId: number): Observable<ReleaseNote> {
        return this.releaseNotesApiService.getReleaseNote(releaseNoteId).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                return throwError(() => errorResponse);
            })
        );
    }

    addReleaseNote(releaseNoteData: ReleaseNote): Observable<ReleaseNote> {
        return this.releaseNotesApiService.addReleaseNote(releaseNoteData).pipe(
            tap(() => {
                this.clearCache();
            }),
            catchError((errorResponse: HttpErrorResponse) => {
                return throwError(() => errorResponse);
            })
        );
    }

    updateReleaseNote(releaseNoteId: number, releaseNoteData: ReleaseNote): Observable<SaveResponse> {
        return this.releaseNotesApiService.updateReleaseNote(releaseNoteId, releaseNoteData).pipe(
            tap(() => {
                this.clearCache();
            }),
            catchError((errorResponse: HttpErrorResponse) => {
                return throwError(() => errorResponse);
            })
        );
    }

    public clearCache() {
        this.cachedReleaseNotes = null;
    }
}
